import { useEffect } from 'react';
import { Link as RouterLink } from 'react-router-dom';

import get from 'lodash/get';
import isEmpty from 'lodash/isEmpty';
import PropTypes from 'prop-types';

import { Link, Typography } from '@mui/material';

import GenericFormContainer from '../Forms/GenericFormContainer';

import { CircularLoaderComponent } from '../LoadingSpinner/LoadingSpinnerComponent';
import LogoComponent from './LogoComponent';

import {
  lengthValidation120,
  required,
  validatePhoneNumber,
} from '../Forms/utils';

import { history } from '../../store';
import { CHECKBOX, PHONE_NUMBER, STYLED_TEXT } from '../Forms/fieldTypes';
import { StyledVerifyContainer } from './styledComponents';

const VerifyComponent = (props) => {
  const {
    form,
    onSubmit,
    initialValues,
    hasAcceptedTerms,
    userData,
    onUserVerified,
  } = props;

  useEffect(() => {
    isEmpty(userData) && history.replace('./');
    userData?.type === 'apple-id' && onUserVerified(userData); // Apple requested to simplify the sign up process - user is automatically verified after a registration
  }, []);

  if (userData?.type === 'apple-id') {
    return <CircularLoaderComponent />;
  }

  const source = get(userData, 'source');

  const formData = [
    {
      keyName: 'firstName',
      label: 'First Name',
      fieldType: STYLED_TEXT,
      validate: [required, lengthValidation120],
    },
    {
      keyName: 'lastName',
      label: 'Last Name',
      fieldType: STYLED_TEXT,
      validate: [required, lengthValidation120],
    },
    {
      keyName: 'email',
      label: 'Email',
      fieldType: STYLED_TEXT,
      validate: [],
      disabled: source === 'email',
    },
    {
      keyName: 'phone_number',
      label: 'Phone Number',
      fieldType: PHONE_NUMBER,
      validate: [validatePhoneNumber],
      disabled: source === 'phone_number',
      showClearPhoneNumber: source !== 'phone_number',
    },
    {
      keyName: 'termsAndConditions',
      label: (
        <span>
          I agree to the&nbsp;
          <Link component={RouterLink} to="/terms-and-conditions">
            Terms & Conditions
          </Link>
        </span>
      ),
      fieldType: CHECKBOX,
      validate: [required],
    },
  ];
  return (
    <StyledVerifyContainer
      container
      direction="column"
      justifyContent="center"
      alignItems="center"
      wrap="nowrap"
    >
      <LogoComponent />
      <Typography variant="h6" sx={{ margin: '2rem 0 0 0' }}>
        Please complete your registration
      </Typography>
      <GenericFormContainer
        form={form}
        formData={formData}
        onSubmit={onSubmit}
        initialValues={initialValues}
        title="Confirm"
        submitText="Confirm and Log in"
        backButton={false}
        isButtonDisabled={!hasAcceptedTerms}
        canBeUpdated={false}
        isCentered
        isFullWidthSubmit
        isFullWidthForm
      />
    </StyledVerifyContainer>
  );
};

VerifyComponent.propTypes = {
  form: PropTypes.string.isRequired,
  onSubmit: PropTypes.func.isRequired,
  initialValues: PropTypes.instanceOf(Object).isRequired,
  userData: PropTypes.instanceOf(Object).isRequired,
  onUserVerified: PropTypes.func.isRequired,
  hasAcceptedTerms: PropTypes.bool.isRequired,
};

export default VerifyComponent;
